import { type SearchTopBar } from "~/components/Components/SearchTopBar/SearchTopBar";
import { type TitleTopBar } from "~/components/Components/TitleTopBar/TitleTopBar";
import { TopBar } from "~/components/Components/TopBar/TopBar";

type Props = {
  isSearchMode: boolean;
  titleTopBarProps: React.ComponentProps<typeof TitleTopBar>;
  searchTopBarProps: React.ComponentProps<typeof SearchTopBar>;
};

export const VoteHeaderModule = (props: Props) => {
  return props.isSearchMode ? (
    <TopBar barType={"search"} topBarProps={props.searchTopBarProps} />
  ) : (
    <TopBar barType={"title"} topBarProps={props.titleTopBarProps} />
  );
};
